export default __webpack_public_path__ + "static/colours-grey-1280x800-1736156dbe0950732ecf5ba5fe92df7c.jpg";